import { NavLink } from "react-router-dom";
import { clearAuth } from "../api";

const navItems = [
  { to: "/campaigns", label: "Campaigns" },
  { to: "/contacts", label: "Contacts" },
  { to: "/inbox", label: "Inbox" },
  { to: "/metrics", label: "Metrics" },
];

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex h-full">
      <aside className="hidden md:flex w-56 flex-col border-r border-ink-200 bg-white">
        <div className="px-5 py-5 border-b border-ink-200">
          <div className="flex items-center gap-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-md bg-ink-900 text-white font-mono text-xs">aem</div>
            <div className="text-sm font-semibold">auto-email-marketer</div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) =>
                `block rounded-md px-3 py-1.5 text-sm transition-colors ${
                  isActive ? "bg-ink-900 text-white" : "text-ink-700 hover:bg-ink-100"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-ink-200 p-3">
          <button
            onClick={() => {
              clearAuth();
              location.reload();
            }}
            className="btn-secondary w-full text-xs"
          >
            Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <div className="mx-auto max-w-5xl px-6 py-6">{children}</div>
      </main>
    </div>
  );
}
